import React from "react";
import Shop from "./Shop";

const Home = () => {
  return <Shop />;
};

export default Home;
